import axios from 'axios';
import {cancelRequest, createCancellation} from '@/utils/axios/cancel-request';

const CheckoutApi = {
  getTotalsWithAllocated(dto = []) {
    cancelRequest('totals');
    const config = createCancellation('totals');

    return axios
      .put('/checkout/multi/allocated-items/totals/', dto, config)
      .then((response) => response?.data?.data)
      .catch((error) => console.log(error));
  },

  updateAllocatedItems(dto = []) {
    return axios
      .put('/checkout/multi/allocated-items/update', dto)
      .then(response => response?.data);
  },
};

export {CheckoutApi};